import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {BackendResponse} from "@app/interfaces/backendResponse";
import {environment} from '@env/environment';
import {ConstantsService} from '@app/services/constants/constants.service';

@Injectable({
    providedIn: 'root'
})

export class OdmoriService {

    private apiURL = environment.apiURL;

    constructor(private httpClient: HttpClient,
        private constants: ConstantsService) {
}

    saveHolidayRequest(data) {
        let params = new HttpParams().set('creator', this.constants.creator_id).set('data', JSON.stringify(data));

        return this.httpClient.get<any>(this.apiURL + '/holidays/saveHolidayRequest', {params: params});
    };

    getHolidayData() {
        let params = new HttpParams().set('creator', this.constants.creator_id);

        return this.httpClient.get<any>(this.apiURL + '/holidays/getHolidayData', {params: params});
    };

    changeStatusOfRequest(request, new_status, requestCopyStatus) {
        let params = new HttpParams().set('creator', this.constants.creator_id).set('request', JSON.stringify(request)).set('new_status', new_status).set('requestCopyStatus', requestCopyStatus);

        return this.httpClient.get<any>(this.apiURL + '/holidays/changeStatusOfRequest', {params: params});
    };

    refuseRequest(reqId, refusalReason, validatorPosition) {
        let params = new HttpParams().set('creator', this.constants.creator_id).set('reqId', reqId).set('refusalReason', refusalReason).set('validatorPosition', validatorPosition);

        return this.httpClient.get<any>(this.apiURL + '/holidays/refuseRequest', {params: params});
    };

    getRequestData(reqId) {
        let params = new HttpParams().set('creator', this.constants.creator_id).set('reqId', reqId);

        return this.httpClient.get<any>(this.apiURL + '/holidays/getRequestData', {params: params});
    };

    saveChangedReplacementEmployee(replacementId, reqId) {
        let params = new HttpParams().set('creator', this.constants.creator_id).set('replacementId', JSON.stringify(replacementId)).set('reqId', reqId);

        return this.httpClient.get<any>(this.apiURL + '/holidays/saveChangedReplacementEmployee', {params: params});
    };

    checkUnfinishedTasksInPeriod() {
        let params = new HttpParams().set('creator', this.constants.creator_id);

        return this.httpClient.get<any>(this.apiURL + '/holidays/checkUnfinishedTasksInPeriod', {params: params});
    };

    getAllHolidayData() {
        let params = new HttpParams().set('creator', this.constants.creator_id);

        return this.httpClient.get<any>(this.apiURL + '/holidays/getAllHolidayData', {params: params});
    };

    countNumberOfUsedDays() {
        let params = new HttpParams().set('creator', this.constants.creator_id);

        return this.httpClient.get<any>(this.apiURL + '/holidays/countNumberOfUsedDays', {params: params});
    };

    saveHolidaysDaysAndHours(users, selectedYear) {
        let params = new HttpParams().set('users', JSON.stringify(users)).set('year', selectedYear);

        return this.httpClient.get<any>(this.apiURL + '/holidays/saveHolidaysDaysAndHours', {params: params});
    };

    getHolidaysDaysAndHours(selectedYear) {
        let params = new HttpParams().set('creator', this.constants.creator_id).set('year', selectedYear);;

        return this.httpClient.get<any>(this.apiURL + '/holidays/getHolidaysDaysAndHours', {params: params});
    };

    recalculateRemainingHolidayDaysAndHoursPerYear(selectedYear, excel) {
        let params = new HttpParams().set('creator', this.constants.creator_id).set('year', selectedYear).set('excel', excel);

        return this.httpClient.get<any>(this.apiURL + '/holidays/recalculateRemainingHolidayDaysAndHoursPerYear', {params: params});
    };

    getAllAbsenceData(excel) {
        let params = new HttpParams().set('creator', this.constants.creator_id).set('excel', excel);

        return this.httpClient.get<any>(this.apiURL + '/holidays/getAllAbsenceData', {params: params});
    };
   
}